import { render, staticRenderFns } from "./EmployeeLeaveAge.vue?vue&type=template&id=0deed1b9"
import script from "./EmployeeLeaveAge.vue?vue&type=script&lang=js"
export * from "./EmployeeLeaveAge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports